

import { Component, Vue, Prop } from "vue-property-decorator";
import { WPAPI } from '@/network/network';
import Loader from '@/components/loader/Loader.vue';
import blog_module from '@/modules/blog/index';

@Component({
  components: { Loader }
})

export default class CS extends Vue {
    
  @Prop({default: ''}) id!: string;

  loading: boolean = false;

  get articles(){
    return blog_module.articles
  }

  async mounted(){

    this.loading = true;

    if (!blog_module.articles?.length){

      const posts: any[] = await WPAPI.get('/posts?categories=' + this.id);

      console.log('posts', posts)

      const articles = posts.map(post => ({...post, title: post.title?.rendered, subtitle: post.excerpt?.rendered}))

      blog_module.setArticles(articles);
      
    }

    this.loading = false;
    
    this.$nextTick(() => {

      this.$emit('loadedArticle');

    })

  }

}

